import { Box, Grid, Paper, styled } from '@mui/material';
import { GridColumnsPanel } from "@mui/x-data-grid-premium";
import { useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import UndoIcon from "@mui/icons-material/Undo";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { useTableViewManager } from "src/core/tables/useTableViews";
import { TableViewDropdown, ViewNameDialog } from "./TableViewDropdown";
import CustomButton from 'src/core/ui/CustomButton';

export const CustomColumnsPanel = ({ tableSettings }) => {
  const { activeViewId, activeViewName, viewsList, handleViewChange, isDirty, canEdit, save, discard, addView, renameView, deleteView, restoreDefaults, } = useTableViewManager(tableSettings, { syncGrid: true });
  const [addOpen, setAddOpen] = useState(false);
  const [renameOpen, setRenameOpen] = useState(false);

  return (
    <div style={{ height: 800, width: 400, maxWidth: 'calc(100vw - 32px)' }}>
      <Paper>
        <Grid container alignItems="center">
          <Grid item xs={7}>
            <TableViewDropdown activeViewId={activeViewId} viewsList={viewsList} handleViewChange={handleViewChange} disabled={!canEdit} />
          </Grid>
          <Grid item xs={1}>
            <CustomButton title="Add new view" tooltipText="Add new view" iconButton size="small" disabled={!canEdit} icon={<AddIcon fontSize="small" />} onClick={() => setAddOpen(true)} />
          </Grid>
          <Grid item xs={1}>
            <CustomButton title="Rename view" tooltipText="Rename view" iconButton size="small" disabled={!canEdit || activeViewId === '0'} icon={<EditIcon fontSize="small" />} onClick={() => setRenameOpen(true)} />
          </Grid>
          <Grid item xs={1}>
            <CustomButton title="Delete view" tooltipText="Delete view" iconButton size="small" disabled={!canEdit || activeViewId === '0'} icon={<DeleteIcon fontSize="small" />} onClick={() => { if (window.confirm(`Delete view “${activeViewName}”?`)) deleteView(activeViewId); }} />
          </Grid>
          <Grid item xs={1}>
            <CustomButton title="Save edits" tooltipText="Save edits" iconButton size="small" disabled={!canEdit || !isDirty} icon={<SaveIcon fontSize="small" />} onClick={save} />
          </Grid>
          <Grid item xs={1}>
            <CustomButton title="Discard edits" tooltipText="Discard edits" iconButton size="small" disabled={!canEdit || !isDirty} icon={<UndoIcon fontSize="small" />} onClick={discard} />
          </Grid>
        </Grid>
        <StyledGridColumnsPanel />
        <Box sx={{ width: 'fit-content', maxWidth: '100%' }}><CustomButton title="Restore application defaults" variant="text" size="small" disabled={!canEdit} onClick={restoreDefaults} /></Box>
        <ViewNameDialog open={addOpen} onClose={() => setAddOpen(false)} onSubmit={addView} title="Create New View" submitLabel="Create" initialValue="New View" />
        <ViewNameDialog open={renameOpen} onClose={() => setRenameOpen(false)} onSubmit={name => renameView(activeViewId, name)} title="Rename View" initialValue={activeViewName} submitLabel="Rename" />
      </Paper>
    </div>
  );
};

const StyledGridColumnsPanel = styled(GridColumnsPanel)(() => ({ ".MuiDataGrid-panelHeader": { display: "none !important" }, }));
